/* riwi-cart-contents.js — Mengen-Stepper und Entfernen fuer snippets/riwi-cart-contents.liquid.
 *
 * Bewusst klein und eigenstaendig: die /cart-Seite muss ohne den Drawer-Controller aus P2
 * funktionieren. P2 uebernimmt dieselben Mutationen fuer den Drawer und darf diese Datei
 * wiederverwenden (window.RiwiCartContents.refreshFrom / mutate).
 *
 * Regeln, die hier gelten:
 * - Erfolg wird NIE per Timer erkannt. Jede Mutation geht ueber /cart/change.js und wird
 *   ausschliesslich an der Antwort gemessen; zusaetzlich liest refreshFrom() den Stand aus
 *   der Section-Antwort. Kein setTimeout als Erfolgsmerkmal.
 * - Das Client-Gate fuer die 0-$-Sperre ist BITGLEICH zum Server-Gate im Snippet:
 *     item.quantity > 0 && item.final_line_price === 0 && item.discounts.length === 0
 *   Dieselben drei Bedingungen, dieselbe Reihenfolge. Aendert sich eine Seite, muss die
 *   andere im selben Commit mitgehen.
 * - Ohne JS bleibt alles bedienbar: die ±-Knoepfe sind type="button" (ohne JS wirkungslos),
 *   das Mengenfeld haengt per form= an der Warenkorb-Form, der "Update"-Knopf ist nur in der
 *   no-js-Fassung sichtbar, und "Entfernen" ist ein echter Link auf url_to_remove.
 *
 * P3-Ergaenzung (Gift-Stage-CTA + Set-only-Upsell "Bag/Couch -20 %"):
 * - riwi-lp2.js ist auf /cart NICHT geladen (nur PDP/LP2-Template) — deshalb hier ein eigener,
 *   minimaler Nachbau von Cart.addAndApply aus riwi-lp2.js: cart/add.js -> vorhandene Codes
 *   aus GET cart.js lesen -> gemergt per cart/update.js setzen -> Leitcode pruefen -> bei
 *   Fehlschlag /discount/-Route als Fallback. (Der cart.js-Schritt ist Pflicht: die
 *   add.js-Antwort fuehrt kein `discount_codes` — F4, s. currentCodes() weiter unten.)
 *   "Gleiche Regeln" heisst hier woertlich: dieselbe Reihenfolge, derselbe Merge, derselbe
 *   Drop-Mechanismus fuer Gratis-Positionen, deren Code nicht griff.
 * - Erfolg wird auch hier NIE per Timer erkannt: nach dem Warenkorb-Umbau wird die Section
 *   per GET /cart?section_id=... neu geholt und ersetzt (dieselbe refreshFrom()-Funktion wie
 *   bei den Mengen-Mutationen oben) — kein setTimeout, kein Optimistic-UI ohne Beleg.
 */
(function () {
  'use strict';

  var BUSY = 'is-busy';

  function root(el) {
    return el.closest('[data-riwi-cart]');
  }

  function sectionId(box) {
    return box.getAttribute('data-rc-section-id') || '';
  }

  /* Client-Gate — Formulierung identisch zum Liquid-Server-Gate. */
  function isZeroBlocked(cart) {
    if (!cart || !cart.items) return false;
    return cart.items.some(function (i) {
      return i.quantity > 0 && i.final_line_price === 0 && i.discounts.length === 0;
    });
  }

  function setError(box, index, message) {
    var target = box.querySelector('#RiwiCartError-' + index);
    if (target) target.textContent = message || '';
  }

  /* Ersetzt den Inhalt aus einer Section-Rendering-Antwort. Wir tauschen nur das
     [data-riwi-cart]-Element, damit umgebende Sections (Banner, Kollektion) stehen bleiben. */
  function refreshFrom(box, html) {
    var parsed = new DOMParser().parseFromString(html, 'text/html');
    var next = parsed.querySelector('[data-riwi-cart]');
    if (!next) return false;
    next.classList.remove('no-js');
    /* P3-Lektion "selbstheilende UI": box wird gleich aus dem DOM entfernt — jeden Timer
       DIESER Box VOR dem Tausch abraeumen, sonst laeuft der Cutoff-Interval an einem
       verwaisten (detached) Element weiter. */
    stopCutoff(box);
    var codeKeep = codePanelState(box);
    var focusRow = box.getAttribute('data-rc-focus-row');
    box.replaceWith(next);
    restoreCodePanels(next, codeKeep);
    if (focusRow !== null) focusAfterRemove(next, Number(focusRow));
    document.dispatchEvent(
      new CustomEvent('riwi-cart:updated', { detail: { container: next }, bubbles: true })
    );
    return true;
  }

  function mutate(box, body) {
    var sid = sectionId(box);
    if (sid) body.sections = sid;
    box.setAttribute('aria-busy', 'true');

    return fetch((window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/') + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (res) {
        return res.json().then(function (data) {
          return { ok: res.ok, status: res.status, data: data };
        });
      })
      .then(function (out) {
        box.removeAttribute('aria-busy');
        if (!out.ok) {
          return { error: (out.data && out.data.description) || (out.data && out.data.message) || String(out.status) };
        }
        var sections = out.data.sections || {};
        var html = sid ? sections[sid] : null;
        if (html && refreshFrom(box, html)) return { ok: true, cart: out.data };
        /* Kein Section-HTML (z. B. fehlende section_id): harter Reload statt stiller Falschstand. */
        window.location.reload();
        return { ok: true, cart: out.data, reloaded: true };
      })
      .catch(function (err) {
        box.removeAttribute('aria-busy');
        return { error: err && err.message ? err.message : 'network' };
      });
  }

  /* ---------------------------------------------------------------- P3: Cart-Weg (add.js)
     Minimaler Nachbau von Cart.addAndApply (riwi-lp2.js) fuer den Kontext ohne die LP2-Datei.
     Dieselbe Abfolge, dieselben Regeln — siehe Kopf-Kommentar. */
  function cartRoot() {
    var r = String((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/');
    return r.charAt(r.length - 1) === '/' ? r : r + '/';
  }
  function cartUrl(path) { return cartRoot() + String(path).replace(/^\/+/, ''); }
  function discountRoute(code, redirectPath) {
    return cartUrl('discount/' + encodeURIComponent(code)) + '?redirect=' + encodeURIComponent(redirectPath || (cartRoot() + 'cart'));
  }
  function mergeCodes(existing, adds) {
    var out = [], seen = {};
    (existing || []).forEach(function (e) {
      var c = (e && e.code ? String(e.code) : '').trim();
      if (c && !seen[c.toUpperCase()]) { seen[c.toUpperCase()] = 1; out.push(c); }
    });
    (adds || []).forEach(function (c) {
      c = (c || '').trim();
      if (c && !seen[c.toUpperCase()]) { seen[c.toUpperCase()] = 1; out.push(c); }
    });
    return out.join(',');
  }
  function findDiscountEntry(cart, code) {
    var list = cart && cart.discount_codes;
    if (!list || !list.length || !code) return null;
    var want = String(code).toUpperCase();
    for (var i = 0; i < list.length; i++) {
      if (String(list[i].code || '').toUpperCase() === want) return list[i];
    }
    return null;
  }
  function postJson(url, payload) {
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (res) {
      return res.json().then(
        function (data) { return { ok: res.ok, status: res.status, data: data }; },
        function () { return { ok: false, status: res.status, data: null }; }
      );
    });
  }

  /* F4 (17.09.2026) — Codes NUR aus dem echten Warenkorb mergen, nie aus der add.js-Antwort.
     Befund QA F1/F2/F3 (reports/riwi-us-cart/qa-f123.md, Kriterium 2+5): POST cart/add.js
     antwortet mit dem LINE-ITEM-Objekt, das KEIN `discount_codes` fuehrt. Der bisherige
     `mergeCodes(add.data && add.data.discount_codes, codes)` las deshalb immer undefined, und
     das folgende cart/update.js ersetzte die Codeliste durch NUR den neuen Code: FREE12-XXL
     verschwand beim Add-on-Kauf still, der Gratis-12er sprang von $0.00 auf $159.95.

     EINE Implementierung fuer beide Dateien: auf PDP/LP2 ist riwi-lp2.js geladen und haelt
     dieselbe Funktion (Cart.currentCodes) — die wird dann benutzt, damit die zwei Dateien
     nicht auseinanderlaufen. Auf /cart ist riwi-lp2.js NICHT geladen, dort greift die lokale,
     verhaltensgleiche Kopie darunter. Beide Fassungen im selben Commit aendern.

     Rueckgabe { ok, status, codes, cart }. ok === false heisst: Zustand UNBEKANNT — Cart-
     Endpunkte werden gedrosselt (429/430) und liefern dann ein LEERES Cart-Objekt; ein leeres
     discount_codes bei Status != 200 ist KEIN Befund, sondern eine Fehlantwort. */
  function currentCodes() {
    var lp2 = window.RiwiLp2Cart;
    if (lp2 && typeof lp2.currentCodes === 'function') return lp2.currentCodes();
    return fetch(cartUrl('cart.js'), {
      credentials: 'same-origin', headers: { Accept: 'application/json' }
    }).then(function (res) {
      if (!res.ok) return { ok: false, status: res.status, codes: [], cart: null };
      return res.json().then(function (cart) {
        var list = cart && cart.discount_codes;
        if (!list || Object.prototype.toString.call(list) !== '[object Array]') {
          return { ok: false, status: res.status, codes: [], cart: cart || null };
        }
        return { ok: true, status: res.status, codes: list, cart: cart };
      }, function () { return { ok: false, status: res.status, codes: [], cart: null }; });
    }, function () { return { ok: false, status: 0, codes: [], cart: null }; });
  }

  /* GET-Section-Refetch statt Navigation: wir sind schon auf /cart bzw. im Drawer, ein
     Redirect auf dieselbe Seite waere unnoetig. Kein Section-HTML da (z. B. fehlende
     section_id) -> harter Reload, nie ein stiller Falschstand.

     F2-BEFUND (17.09.2026, am Staging mit CDP gemessen): Im DRAWER war der Weg unten falsch.
     `cart?section_id=riwi-cart-drawer` trifft den `template.name != 'cart'`-Guard in
     sections/riwi-cart-drawer.liquid — die Antwort enthaelt kein [data-riwi-cart], also lief
     der Notnagel `window.location.reload()`: der Drawer schloss sich nach JEDEM Klick auf
     "Add your free bag" / den Upsell-Knopf, statt offen zu bleiben. Dieselbe Falle, die P2 in
     assets/riwi-cart.js schon geloest hat (currentSectionsUrl: NIE gegen /cart refetchen).
     Genau dorthin wird jetzt delegiert, statt die Loesung ein zweites Mal zu bauen. Betrifft
     Gift-Stage-CTA, Upsell und den F2-Zubehoerblock gleichermassen. */
  function refetchSection(box) {
    if (box.getAttribute('data-rc-context') === 'drawer'
        && window.RiwiCartDrawer && typeof window.RiwiCartDrawer.refresh === 'function') {
      return Promise.resolve(window.RiwiCartDrawer.refresh());
    }
    var sid = sectionId(box);
    if (!sid) { window.location.reload(); return Promise.resolve(); }
    return fetch(cartUrl('cart') + '?section_id=' + encodeURIComponent(sid), {
      headers: { Accept: 'text/html' }
    })
      .then(function (res) { return res.text(); })
      .then(function (html) {
        if (!refreshFrom(box, html)) window.location.reload();
      })
      ['catch'](function () { window.location.reload(); });
  }

  /* opts: { items: [{id, quantity}], codes: [string], dropIfCodeFails: [{id, code}] }
     Liefert ein Promise, das im Erfolgsfall die Section neu geladen hat. Bei Fehler wird
     onError(message) aufgerufen und NICHTS am Warenkorb geaendert (Netzwerkfehler heisst:
     Zustand unbekannt -> nicht weiterlaufen). */
  function addAndApply(box, opts) {
    var items = (opts && opts.items) || [];
    var codes = ((opts && opts.codes) || []).filter(Boolean);
    var drop = (opts && opts.dropIfCodeFails) || [];
    var onError = (opts && opts.onError) || function () {};
    if (!items.length) { onError('Something went wrong — please try again.'); return Promise.resolve(); }
    if (typeof fetch !== 'function') { onError('Something went wrong — please try again.'); return Promise.resolve(); }

    return postJson(cartUrl('cart/add.js'), { items: items }).then(function (add) {
      if (!add.ok) {
        var why = add.data && (add.data.description || add.data.message);
        onError(why || 'Something went wrong — please try again.');
        return;
      }
      if (!codes.length) return refetchSection(box);

      /* Erst den AKTUELLEN Warenkorb lesen, dann mergen — nie aus der add.js-Antwort. */
      return currentCodes().then(function (state) {
        if (!state.ok) {
          /* Zustand unbekannt (Drosselung/Netz). Eine update.js-Liste aus NUR den neuen Codes
             wuerde einen bereits gesetzten Rabatt (FREE12-XXL/FREEBAG-24) still loeschen ->
             Codes-Schritt auslassen und NICHTS weiter mutieren. Der Refetch zeigt danach den
             echten Warenkorb-Stand, kein Optimistic-UI. */
          console.warn('[riwi-cart] cart.js nicht lesbar (Status ' + state.status + ') - ' +
            'Rabattcodes werden NICHT gesetzt, um bestehende Codes nicht zu ueberschreiben.', codes);
          return refetchSection(box);
        }
        var merged = mergeCodes(state.codes, codes);
        return postJson(cartUrl('cart/update.js'), { discount: merged }).then(function (upd) {
          var removals = [];
          drop.forEach(function (d) {
            if (!d || !d.code || !d.id) return;
            var entry = upd.ok ? findDiscountEntry(upd.data, d.code) : null;
            if (entry && entry.applicable === true) return;
            var keep = 0;
            items.forEach(function (it) { if (String(it.id) === String(d.id)) keep += (it.quantity || 1); });
            drop.forEach(function (o) { if (o && String(o.id) === String(d.id)) keep -= 1; });
            if (keep < 0) keep = 0;
            removals.push(postJson(cartUrl('cart/change.js'), { id: String(d.id), quantity: keep })['catch'](function () {}));
          });
          var after = removals.length ? Promise.all(removals) : Promise.resolve();
          return after.then(function () {
            if (!codes.length) return refetchSection(box);
            var primary = codes[0];
            var primaryEntry = upd.ok ? findDiscountEntry(upd.data, primary) : null;
            if (primaryEntry && primaryEntry.applicable === true) return refetchSection(box);
            /* Leitcode nicht anwendbar: Fallback /discount/-Route wie in riwi-lp2.js — der
               Kunde landet ueber den Redirect wieder auf /cart, der Code kommt als Cookie mit. */
            window.location.href = discountRoute(primary, cartUrl('cart'));
          });
        });
      });
    })['catch'](function () {
      onError('Something went wrong — please try again.');
    });
  }

  function lineOf(el) {
    return el.closest('[data-rc-line]');
  }

  function changeLine(line, quantity) {
    var box = root(line);
    if (!box) return;
    var index = line.getAttribute('data-rc-index');
    setError(box, index, '');
    line.classList.add(BUSY);
    mutate(box, { line: Number(index), quantity: quantity }).then(function (out) {
      line.classList.remove(BUSY);
      if (out && out.error) {
        var stillThere = document.querySelector('[data-riwi-cart]');
        if (stillThere) setError(stillThere, index, out.error);
      }
    });
  }

  document.addEventListener('click', function (event) {
    var step = event.target.closest('[data-rc-step]');
    if (step && !step.disabled) {
      var line = lineOf(step);
      if (!line) return;
      var input = line.querySelector('[data-rc-qty-input]');
      var current = Number(input && input.value) || Number(line.getAttribute('data-rc-qty')) || 0;
      var next = current + Number(step.getAttribute('data-rc-step'));
      if (next < 0) next = 0;
      event.preventDefault();
      changeLine(line, next);
      return;
    }

    var remove = event.target.closest('[data-rc-remove]');
    if (remove) {
      var rline = lineOf(remove);
      if (!rline) return;
      event.preventDefault();
      changeLine(rline, 0);
    }
  });

  document.addEventListener('change', function (event) {
    var input = event.target.closest('[data-rc-qty-input]');
    if (!input) return;
    var line = lineOf(input);
    if (!line) return;
    var value = Number(input.value);
    if (!Number.isFinite(value) || value < 0) value = 0;
    changeLine(line, value);
  });

  /* ---------------------------------------------------------- P3: Gift-Stage-CTA
     "Add your free bag" / "Add 12 blocks free" — je EIN Artikel + der zugehoerige, im
     Snippet fest verdrahtete Code (FREEBAG-24 / FREE12-XXL). dropIfCodeFails nimmt die
     Position wieder heraus, falls der Code (z. B. deaktiviert im Admin) nicht greift —
     nie eine Gratis-Zusage kassieren, die der Warenkorb nicht gewaehrt. */
  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-rc-add-gift]');
    if (!btn || btn.disabled) return;
    var box = root(btn);
    if (!box) return;
    var wrap = btn.closest('.riwi-cart__gift');
    var errorEl = wrap ? wrap.querySelector('[data-rc-gift-error]') : null;
    var variantId = parseInt(btn.getAttribute('data-rc-gift-variant'), 10) || 0;
    var code = (btn.getAttribute('data-rc-gift-code') || '').trim();
    if (!variantId || !code) return;
    event.preventDefault();
    var wasDisabled = btn.disabled;
    btn.disabled = true;
    btn.setAttribute('aria-busy', 'true');
    if (errorEl) errorEl.textContent = '';
    addAndApply(box, {
      items: [{ id: variantId, quantity: 1 }],
      codes: [code],
      dropIfCodeFails: [{ id: variantId, code: code }],
      onError: function (msg) {
        btn.disabled = wasDisabled;
        btn.removeAttribute('aria-busy');
        if (errorEl) errorEl.textContent = msg;
      }
    });
  });

  /* ---------------------------------------------------------- P3: Set-only-Upsell
     Farbwahl (Radiogroup) + "Add to cart" fuer Bag/Couch -20 % (STORE20). Menge ist immer 1
     (im Markup so vorgegeben) — hier wird nur die WAHL, nie eine Menge, veraendert. */
  function formatMoneyLike(sampleText, cents) {
    var amount = (cents / 100).toFixed(2);
    var parts = amount.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var symbolMatch = sampleText && sampleText.match(/^[^\d]*/);
    var symbol = symbolMatch && symbolMatch[0] ? symbolMatch[0] : '$';
    /* F42 (16.10.2026): wie Liquid money_without_trailing_zeros - ",00" entfaellt, sonst 2 Stellen.
       Waehrungscode wie im Theme: nur wenn der Beispieltext einen traegt (Nicht-USD, z. B. " CAD"). */
    var codeMatch = sampleText && sampleText.match(/\s([A-Z]{3})\s*$/);
    var code = codeMatch ? ' ' + codeMatch[1] : '';
    if (parts[1] === '00') return symbol + parts[0] + code;
    return symbol + parts.join('.') + code;
  }

  document.addEventListener('click', function (event) {
    var swatch = event.target.closest('[data-rc-upsell-swatch]');
    if (swatch) {
      var group = swatch.closest('.riwi-cart__upsell-swatches');
      if (!group) return;
      group.querySelectorAll('[data-rc-upsell-swatch]').forEach(function (s) {
        s.setAttribute('aria-checked', s === swatch ? 'true' : 'false');
      });
      var upsellBox = swatch.closest('.riwi-cart__upsell');
      if (upsellBox) {
        var input = upsellBox.querySelector('[data-rc-upsell-variant]');
        if (input) input.value = swatch.getAttribute('data-rc-variant-id') || '';
        var priceOld = upsellBox.querySelector('[data-rc-upsell-price-old]');
        var priceNew = upsellBox.querySelector('[data-rc-upsell-price-new]');
        var cents = Number(swatch.getAttribute('data-rc-price')) || 0;
        if (priceOld && cents) priceOld.textContent = formatMoneyLike(priceOld.textContent, cents);
        if (priceNew && cents) priceNew.textContent = formatMoneyLike(priceNew.textContent, Math.round(cents * 0.8));
      }
      return;
    }

    var addBtn = event.target.closest('[data-rc-upsell-add]');
    if (!addBtn || addBtn.disabled) return;
    var box = root(addBtn);
    var upsell = addBtn.closest('.riwi-cart__upsell');
    if (!box || !upsell) return;
    var variantInput = upsell.querySelector('[data-rc-upsell-variant]');
    var variantId = parseInt((variantInput && variantInput.value) || '', 10) || 0;
    var code = (upsell.getAttribute('data-rc-upsell-code') || '').trim();
    var errorEl = upsell.querySelector('[data-rc-upsell-error]');
    if (!variantId || !code) return;
    var wasDisabled = addBtn.disabled;
    addBtn.disabled = true;
    addBtn.setAttribute('aria-busy', 'true');
    if (errorEl) errorEl.textContent = '';
    addAndApply(box, {
      items: [{ id: variantId, quantity: 1 }],
      codes: [code],
      onError: function (msg) {
        addBtn.disabled = wasDisabled;
        addBtn.removeAttribute('aria-busy');
        if (errorEl) errorEl.textContent = msg;
      }
    });
  });

  /* ---- Rabattcode-Feld (snippets/riwi-cart-discounts.liquid, code_field) --------------------
     Ablauf Anwenden:
       1. bestehende Codes aus cart.js (nie aus einer add.js-Antwort); nicht lesbar -> Fehler,
          nichts senden (sonst wuerde update.js die Liste ERSETZEN und FREE12-XXL/FREEBAG-24
          loeschen)
       2. update.js {discount: "BESTEHEND,NEU"}
       3. neuer Code applicable -> Section neu rendern
          neuer Code nicht applicable ODER ein vorher greifender Code greift nicht mehr
          (Kombinations-Konflikt) -> alte Liste zuruecksetzen + Hinweis "ungueltig"
       4. 429 / HTML (Bot-Schutz) / Netzfehler -> allgemeine Fehlermeldung, kein Rueckbau
          auf Verdacht (Zustand unbekannt). postJson/currentCodes liefern dann ok:false,
          weil res.json() an einer HTML-Antwort scheitert. */
  var CODE_ERROR_FALLBACK = 'Something went wrong — please try again.';
  function codeUi(box) {
    var wrap = box && box.querySelector('[data-rc-code-form]');
    if (!wrap) return null;
    return {
      wrap: wrap,
      input: wrap.querySelector('input[data-rc-code-input]'),
      btn: wrap.querySelector('button[data-rc-code-apply]'),
      msg: wrap.querySelector('[data-rc-code-msg]')
    };
  }
  function codeErrorText(ui) {
    return (ui && ui.msg && ui.msg.getAttribute('data-rc-msg-error')) || CODE_ERROR_FALLBACK;
  }
  function codeMsg(ui, text, isError) {
    if (!ui || !ui.msg) return;
    ui.msg.textContent = text || '';
    ui.msg.classList.toggle('is-error', !!(text && isError));
    if (ui.input) {
      if (text && isError) ui.input.setAttribute('aria-invalid', 'true');
      else ui.input.removeAttribute('aria-invalid');
    }
  }
  function codeBusy(ui, on) {
    if (!ui) return;
    if (ui.btn) {
      ui.btn.disabled = !!on;
      if (on) ui.btn.setAttribute('aria-busy', 'true'); else ui.btn.removeAttribute('aria-busy');
    }
    ui.wrap.classList.toggle(BUSY, !!on);
  }
  function codeList(entries) {
    return (entries || []).map(function (e) { return e && e.code ? String(e.code).trim() : ''; }).filter(Boolean);
  }
  function applicableCodes(cart) {
    return ((cart && cart.discount_codes) || []).filter(function (e) { return e && e.applicable === true; })
      .map(function (e) { return String(e.code).toUpperCase(); });
  }
  /* Setzt die Codeliste exakt (leer = alle Codes entfernen). */
  function setCodes(list) {
    return postJson(cartUrl('cart/update.js'), { discount: (list || []).join(',') });
  }

  function applyCodeFromField(box) {
    var ui = codeUi(box);
    if (!ui || !ui.input || (ui.btn && ui.btn.disabled)) return;
    var code = String(ui.input.value || '').trim();
    if (!code) { ui.input.focus(); return; }
    var invalid = (ui.msg && ui.msg.getAttribute('data-rc-msg-invalid')) || codeErrorText(ui);
    codeMsg(ui, '', false);
    codeBusy(ui, true);
    function fail(text, isInvalid) {
      codeBusy(ui, false);
      openCodePanel(ui);
      codeMsg(ui, text, true);
      if (isInvalid && ui.input) { ui.input.focus(); ui.input.select(); }
    }
    currentCodes().then(function (state) {
      if (!state || !state.ok) { fail(codeErrorText(ui)); return; }
      var before = codeList(state.codes);
      var beforeOk = applicableCodes(state.cart);
      var already = before.some(function (c) { return c.toUpperCase() === code.toUpperCase(); });
      if (already && beforeOk.indexOf(code.toUpperCase()) !== -1) {
        ui.input.value = '';
        ui.wrap.setAttribute('data-rc-code-close', '');
        return refetchSection(box);
      }
      return postJson(cartUrl('cart/update.js'), { discount: mergeCodes(state.codes, [code]) }).then(function (upd) {
        if (!upd.ok || !upd.data) { fail(codeErrorText(ui)); return; }
        var entry = findDiscountEntry(upd.data, code);
        var nowOk = applicableCodes(upd.data);
        var lost = beforeOk.filter(function (c) { return nowOk.indexOf(c) === -1; });
        if (entry && entry.applicable === true && !lost.length) {
          ui.input.value = '';
          ui.wrap.setAttribute('data-rc-code-close', '');
          return refetchSection(box);
        }
        /* Nur den neuen Code wieder herausnehmen, die vorherige Liste bleibt unveraendert. */
        var restore = before.filter(function (c) { return c.toUpperCase() !== code.toUpperCase(); });
        return setCodes(restore).then(function (back) {
          if (!back.ok) console.warn('[riwi-cart] Rueckbau der Codeliste fehlgeschlagen (Status ' + back.status + ').');
          fail(invalid, true);
        }, function () { fail(invalid, true); });
      }, function () { fail(codeErrorText(ui)); });
    }, function () { fail(codeErrorText(ui)); });
  }

  function removeCode(btn) {
    var box = root(btn);
    if (!box || btn.disabled) return;
    var code = String(btn.getAttribute('data-rc-remove-code') || '').trim();
    if (!code) return;
    var ui = codeUi(box);
    btn.disabled = true;
    codeMsg(ui, '', false);
    function fail() { btn.disabled = false; openCodePanel(ui); codeMsg(ui, codeErrorText(ui), true); }
    currentCodes().then(function (state) {
      if (!state || !state.ok) { fail(); return; }
      var rest = codeList(state.codes).filter(function (c) { return c.toUpperCase() !== code.toUpperCase(); });
      return setCodes(rest).then(function (upd) {
        if (!upd.ok) { fail(); return; }
        box.setAttribute('data-rc-focus-row', String(Array.prototype.indexOf.call(box.querySelectorAll('button[data-rc-remove-code]'), btn)));
        return refetchSection(box);
      }, fail);
    }, fail);
  }

  document.addEventListener('click', function (event) {
    var apply = event.target.closest('button[data-rc-code-apply]');
    if (apply) {
      var box = root(apply);
      if (!box) return;
      event.preventDefault();
      applyCodeFromField(box);
      return;
    }
    var rm = event.target.closest('button[data-rc-remove-code]');
    if (rm) {
      event.preventDefault();
      removeCode(rm);
    }
  });
  /* Enter im Feld = Anwenden (nicht das Cart-Formular absenden). */
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter' || event.isComposing) return;
    var input = event.target.closest && event.target.closest('input[data-rc-code-input]');
    if (!input) return;
    event.preventDefault();
    var box = root(input);
    if (box) applyCodeFromField(box);
  });
  document.addEventListener('input', function (event) {
    var input = event.target.closest && event.target.closest('input[data-rc-code-input]');
    if (!input) return;
    var box = root(input);
    var ui = box && codeUi(box);
    if (ui && ui.msg && ui.msg.textContent) codeMsg(ui, '', false);
  });

  /* Eingeklapptes Code-Feld: [data-rc-code-toggle] (aria-expanded/aria-controls) klappt das
     Panel [data-rc-code-form] auf und zu. Das Panel kommt mit hidden vom Server; ohne JS macht
     eine noscript-Regel es sichtbar. Offen-Zustand, Eingabe, Meldung und Fokus ueberstehen jeden
     Section-Swap (refreshFrom). Nach erfolgreichem Anwenden (data-rc-code-close) bleibt es zu,
     der Code steht dann als eigene Zeile da. */
  function codeUiOf(wrap) {
    return {
      wrap: wrap,
      input: wrap.querySelector('input[data-rc-code-input]'),
      btn: wrap.querySelector('button[data-rc-code-apply]'),
      msg: wrap.querySelector('[data-rc-code-msg]')
    };
  }
  function codePanelById(box, id) {
    var hit = null;
    if (!box || !id) return hit;
    box.querySelectorAll('[data-rc-code-form][id]').forEach(function (w) { if (!hit && w.id === id) hit = w; });
    return hit;
  }
  function codeToggleFor(wrap) {
    var box = wrap && root(wrap);
    var hit = null;
    if (!box || !wrap.id) return hit;
    box.querySelectorAll('[data-rc-code-toggle]').forEach(function (t) {
      if (!hit && t.getAttribute('aria-controls') === wrap.id) hit = t;
    });
    return hit;
  }
  function setCodeOpen(wrap, open, animate) {
    if (!wrap) return;
    wrap.hidden = !open;
    var t = codeToggleFor(wrap);
    if (t) t.setAttribute('aria-expanded', open ? 'true' : 'false');
    wrap.classList.remove('is-opening');
    if (open && animate) { void wrap.offsetWidth; wrap.classList.add('is-opening'); }
  }
  function openCodePanel(ui) {
    if (ui && ui.wrap && ui.wrap.hidden) setCodeOpen(ui.wrap, true, false);
  }
  /* Nach dem Entfernen eines Codes: Fokus auf die naechste verbleibende x-Schaltflaeche, sonst auf den Link. */
  function focusAfterRemove(next, index) {
    var rows = next.querySelectorAll('button[data-rc-remove-code]');
    var target = rows.length ? rows[Math.min(Math.max(index, 0), rows.length - 1)] : next.querySelector('[data-rc-code-toggle]');
    if (!target) return;
    try { target.focus({ preventScroll: true }); } catch (e) { target.focus(); }
  }
  function codePanelState(box) {
    var out = [];
    if (!box) return out;
    box.querySelectorAll('[data-rc-code-form][id]').forEach(function (wrap) {
      if (wrap.hidden) return;
      if (wrap.hasAttribute('data-rc-code-close')) {
        /* Erfolg: Panel bleibt zu, der Fokus geht an den Link (das Feld verschwindet). */
        var a = document.activeElement;
        out.push({ id: wrap.id, closed: true, focus: !a || a === document.body || wrap.contains(a) });
        return;
      }
      var ui = codeUiOf(wrap);
      out.push({
        id: wrap.id,
        value: ui.input ? ui.input.value : '',
        msg: ui.msg ? ui.msg.textContent : '',
        err: !!(ui.msg && ui.msg.classList.contains('is-error')),
        focus: !!(ui.input && document.activeElement === ui.input)
      });
    });
    return out;
  }
  function restoreCodePanels(next, list) {
    (list || []).forEach(function (s) {
      var wrap = codePanelById(next, s.id);
      if (!wrap) return;
      if (s.closed) {
        var t = codeToggleFor(wrap);
        if (t && s.focus) { try { t.focus({ preventScroll: true }); } catch (e) { t.focus(); } }
        return;
      }
      setCodeOpen(wrap, true, false);
      var ui = codeUiOf(wrap);
      if (ui.input && s.value) ui.input.value = s.value;
      if (s.msg) codeMsg(ui, s.msg, s.err);
      if (s.focus && ui.input) {
        try { ui.input.focus({ preventScroll: true }); } catch (e) { ui.input.focus(); }
      }
    });
  }
  document.addEventListener('click', function (event) {
    var t = event.target.closest && event.target.closest('button[data-rc-code-toggle]');
    if (!t) return;
    var wrap = codePanelById(root(t), t.getAttribute('aria-controls'));
    if (!wrap) return;
    event.preventDefault();
    var open = wrap.hidden;
    setCodeOpen(wrap, open, true);
    if (open) {
      var input = wrap.querySelector('input[data-rc-code-input]');
      if (input) input.focus();
    }
  });
  document.addEventListener('keydown', function (event) {
    if ((event.key !== 'Escape' && event.key !== 'Esc') || event.isComposing) return;
    var wrap = event.target.closest && event.target.closest('[data-rc-code-form]');
    if (!wrap || wrap.hidden) return;
    var t = codeToggleFor(wrap);
    if (!t) return;
    event.preventDefault();
    setCodeOpen(wrap, false, false);
    t.focus();
  });

  /* ---------------------------------------------------------- P3: Cut-off-Countdown
     NUR wenn data-rc-cutoff-hour eine Stunde (0-23) traegt — sonst steht schon der statische
     Locale-Text da und hier passiert nichts. Selbstheilend: EIN Timer in einer Variable je
     Box, vor jedem Neustart geklaert (Section-Swap via refreshFrom ruft initCutoff erneut). */
  var cutoffTimers = new WeakMap();

  function ctHourNow() {
    var parts = new Intl.DateTimeFormat('en-US', {
      timeZone: 'America/Chicago', hour: 'numeric', hour12: false
    }).formatToParts(new Date());
    for (var i = 0; i < parts.length; i++) {
      if (parts[i].type === 'hour') return Number(parts[i].value) % 24;
    }
    return null;
  }

  function renderCutoffText(el, cutoffHour) {
    var textEl = el.querySelector('[data-rc-cutoff-text]');
    if (!textEl) return;
    var nowHour = ctHourNow();
    if (nowHour === null) return;
    if (nowHour < cutoffHour) {
      var remaining = cutoffHour - nowHour;
      textEl.textContent = 'Order within the next ' + remaining + 'h (by ' + cutoffHour + ':00 CT) to ship today.';
    } else {
      textEl.textContent = "Today's cutoff has passed — ships next business day.";
    }
  }

  function stopCutoff(box) {
    box.querySelectorAll('[data-rc-cutoff-hour]').forEach(function (el) {
      var old = cutoffTimers.get(el);
      if (old) { window.clearInterval(old); cutoffTimers.delete(el); }
    });
  }

  function initCutoff(box) {
    box.querySelectorAll('[data-rc-cutoff-hour]').forEach(function (el) {
      var old = cutoffTimers.get(el);
      if (old) { window.clearInterval(old); cutoffTimers.delete(el); }
      var raw = el.getAttribute('data-rc-cutoff-hour');
      var hour = raw === '' || raw === null ? NaN : Number(raw);
      if (!Number.isFinite(hour) || hour < 0 || hour > 23) return; /* leer = statischer Text bleibt stehen */
      renderCutoffText(el, hour);
      var id = window.setInterval(function () { renderCutoffText(el, hour); }, 60000);
      cutoffTimers.set(el, id);
    });
  }

  /* ------------------------------------------- C4: Lieferdatum der Trust-Zeile (data-edd)
     Das Markup kommt aus snippets/riwi-atc-trust.liquid — DEMSELBEN Snippet, das die
     Bausteine-PDP unter dem Kaufbutton rendert. Die Spanne steht als Werktage in
     data-edd-min / data-edd-max; das Datum rechnet der Browser, weil Liquid die Zeitzone
     des Besuchers nicht kennt.

     ⚠️ ZWEITE IMPLEMENTIERUNG DERSELBEN RECHNUNG. Die erste steht in assets/riwi-lp2.js
     ("Voraussichtliche Lieferung"); der Warenkorb laedt riwi-lp2.js bewusst nicht (110 KB
     fuer 15 Zeilen). Wer die Werktags-Regel oder das Datumsformat aendert, muss BEIDE
     Stellen im selben Commit anfassen — sonst nennt die PDP ein anderes Datum als der
     Warenkorb. Dieselben Regeln: Sa/So werden uebersprungen, Format en-US kurz. */
  function eddAdd(d, n) {
    var x = new Date(d.getTime()), c = 0;
    while (c < n) { x.setDate(x.getDate() + 1); if (x.getDay() !== 0 && x.getDay() !== 6) c++; }
    return x;
  }

  function eddFmt(d) {
    try { return d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' }); }
    catch (e) { return d.toDateString(); }
  }

  function initEdd(box) {
    box.querySelectorAll('[data-edd]').forEach(function (el) {
      var min = parseInt(el.getAttribute('data-edd-min'), 10) || 2;
      var max = parseInt(el.getAttribute('data-edd-max'), 10) || 5;
      if (!(min > 0) || !(max >= min)) return; /* unbrauchbare Spanne: Liquid-Fallback bleibt stehen */
      var now = new Date();
      el.textContent = eddFmt(eddAdd(now, min)) + ' – ' + eddFmt(eddAdd(now, max));
    });
  }

  /* ------------------------------------------------- F2: Zubehoer-Add-on-Block nachladen
     Owner 17.09.2026: der Add-on-Block der Bausteine-PDP steht jetzt im Warenkorb (Fall
     "Set im Korb"). Sein Verhalten liegt in assets/riwi-lp2-addons.js — einer EIGENEN Datei,
     damit der sitewide gerenderte Drawer nicht riwi-lp2.js (122 KB roh, ~45 KB ueber CDN) auf
     jede Seite zieht. Geladen wird sie deshalb ERST, wenn wirklich ein Block im DOM steht.

     WARUM HIER und nicht als <script> im Snippet: assets/riwi-cart.js tauscht bei jedem
     Refresh nur den Knoten [data-riwi-cart] aus (DOMParser + replaceWith). Ein so eingehaengtes
     <script src> fuehrt der Browser NICHT aus — ein <link rel="stylesheet"> dagegen schon,
     deshalb reist das CSS im Block mit und nur das JS wird hier nachgezogen.

     Auf LP2/PDP ist die Datei schon ueber riwi-lp2-head.liquid geladen; sie schuetzt sich
     selbst (window.__riwiLp2AddonsInit) und mountet neue Cart-Bloecke ueber ihren eigenen
     riwi-cart:updated-Hoerer. Hier wird also nur EINMAL das <script> ergaenzt. */
  var addonsScriptState = null; /* null = nichts getan, 'pending'/'done' = <script> haengt */

  function ensureAddonsScript() {
    if (addonsScriptState) return;
    if (window.RiwiLp2AddonsCore) { addonsScriptState = 'done'; return; }
    var scope = document.querySelector('[data-rc-addons-scope][data-rc-addons-src]');
    if (!scope) return;
    var src = (scope.getAttribute('data-rc-addons-src') || '').trim();
    if (!src) return;
    addonsScriptState = 'pending';
    var s = document.createElement('script');
    s.src = src;
    s.defer = true;
    s.addEventListener('load', function () {
      addonsScriptState = 'done';
      /* Die Datei mountet beim Laden selbst, was gerade im DOM steht. Kam der Block waehrend
         des Ladens durch einen weiteren Section-Swap neu herein, holt das hier nach. */
      if (window.RiwiLp2AddonsCore) window.RiwiLp2AddonsCore.mountCartBlocks();
    });
    s.addEventListener('error', function () {
      /* Nachladen gescheitert = kein Zubehoer-Angebot. Der Warenkorb selbst bleibt voll
         bedienbar; der Knopf im Block steht serverseitig auf disabled und bleibt es. */
      addonsScriptState = null;
      console.error('[riwi-cart] Zubehoer-Modul konnte nicht geladen werden:', src);
    });
    document.head.appendChild(s);
  }

  /* ---------------------------------------------------- W28-.us: Sticky-Checkout-Leiste
     (mobil, /cart) -- Skizze design/skizzen/2026-09-30-riwi-cart-sticky-checkout.html,
     Varianten A/B/D. Markup + Portal-Ziel in snippets/riwi-cart-contents.liquid
     (data-rc-sticky-checkout, nur rc_ctx == 'page').

     Mechanismus wie die PDP-Sticky-ATC (assets/riwi-lp2.js .sticky-atc): EIN Portal-Knoten
     am <body>, IntersectionObserver auf den Haupt-Checkout-Button (data-rc-checkout) statt
     einen Timer, Fremd-Widget-Offset per CSS-Variable. ANDERS als die PDP-Leiste: dort ist
     "false" von isIntersecting zweideutig (oberhalb ODER unterhalb des Viewports) und nur
     "oberhalb" soll die Leiste zeigen -- hier ist die Anzeige-Regel SYMMETRISCH (Auftrag
     Punkt 3: "solange NICHT im Viewport", oben UND unten), die Ambiguitaet faellt also weg;
     threshold 0 trifft "aus, sobald der Knopf >=1px sichtbar ist" exakt.

     Der Anker (data-rc-checkout) wird durch die Leiste selbst NICHT bewegt: die Leiste ist
     position:fixed/im Portal, der Anker bleibt normaler Fluss-Inhalt in .riwi-cart__summary
     (Lektion "ein Trigger darf nie ein Element beobachten, das er durch seine eigene Wirkung
     bewegt" -- gilt hier nicht, weil kein Bezug besteht).

     Jede Section-Rendering-Aktualisierung ersetzt [data-riwi-cart] KOMPLETT (refreshFrom oben,
     box.replaceWith) -- die Box aus initStickyCheckout() ist deshalb bei JEDEM activate()-Lauf
     eine NEUE, frisch server-gerenderte Leiste mit korrektem Stand (Summe/Sparbetrag/
     disabled kommen 1:1 aus Liquid, keine zweite Rechnung/kein Sync noetig). Der alte
     Beobachter/Timer/Chat-Offset wird darum bei jedem Lauf zuerst hart abgeraeumt
     (stickyTeardown), sonst beobachtet ein Zombie-IO ein bereits ersetztes Element weiter
     und zwei Ticker liefen gegeneinander. */
  var stickyTeardown = null;

  function initStickyCheckout(box) {
    /* Nie im Drawer (Auftrag Punkt 2) -- Gate ZUERST, vor jedem Teardown: ein zweiter Lauf
       ueber eine Drawer-Box (falls der Drawer je enabled=true waere) darf die Leiste der
       Seiten-Box nicht abraeumen. */
    if (box.getAttribute('data-rc-context') !== 'page') return;
    if (stickyTeardown) { stickyTeardown(); stickyTeardown = null; }
    if (!('IntersectionObserver' in window)) return; /* progressive enhancement: ohne IO keine Leiste */

    var bar = box.querySelector('[data-rc-sticky-checkout]');
    var anchor = box.querySelector('[data-rc-checkout]');
    if (!bar || !anchor) return; /* leerer Warenkorb: kein Checkout-Knopf -> keine Leiste */

    var portal = document.getElementById('RiwiCartStickyPortal');
    if (!portal) {
      portal = document.createElement('div');
      portal.id = 'RiwiCartStickyPortal';
      portal.className = 'riwi-cart is-js';
      document.body.appendChild(portal);
    }
    /* Immer genau EIN Kind: eine Leiste einer frueheren Box koennte sonst als Leiche stehen
       bleiben (portal.appendChild allein wuerde nur ANFUEGEN, nicht ersetzen). */
    while (portal.firstChild) portal.removeChild(portal.firstChild);
    portal.appendChild(bar);

    /* Gate-2-Fix (30.09.2026, .com-Fund, betrifft dasselbe Muster hier): Rabatt-/Versand-Apps
       injizieren ihr eigenes Markup VOR JEDEN Button mit name="checkout" (z. B. der .com-Fund
       .scDiscount__container) -- das traf auf .com auch die Sticky-Leiste. Live-Pruefung
       30.09.2026 (riwi-buildit.us/cart, echter Warenkorb + 4s Wartezeit): AUSSER Shopifys
       eigenem "shopify-accelerated-checkout"-Markup (nativ, kein Fremd-Widget) und Judge.me
       (Review-Skripte, kein Checkout-Bezug) wurde KEIN Fremd-Widget neben dem Checkout-Knopf
       gefunden -- Selektor `[class*="scDiscount"]` traf 0x. Trotzdem defensiv wie auf .com:
       der Sticky-Knopf traegt bewusst KEIN name="checkout"/form-Attribut mehr (kann von so
       einer App also gar nicht erst als Ziel erkannt werden) UND ein MutationObserver raeumt
       jeden fremd eingefuegten Knoten aus der Leiste selbst. */
    var btn = bar.querySelector('[data-rc-sticky-btn]');
    var KNOWN_BAR_CHILD_SEL = '.riwi-cart__sticky-meta, .riwi-cart__sticky-btn';
    var barObserver = new window.MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        m.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) { node.parentNode && node.parentNode.removeChild(node); return; }
          if (!node.matches(KNOWN_BAR_CHILD_SEL)) node.remove();
        });
      });
    });
    barObserver.observe(bar, { childList: true });

    if (btn) {
      btn.addEventListener('click', function () {
        /* Kein zweiter Kaufweg: der Klick loest NUR den Haupt-Knopf aus (identisches
           name="checkout" + form dort) -- disabled/0-$-Sperre wird hier gespiegelt statt
           ueber ein form-Attribut vererbt, weil der Sticky-Knopf jetzt type="button" ist. */
        if (btn.disabled || anchor.disabled) return;
        anchor.click();
      });
    }

    var HIDE_MS = 320; /* etwas mehr als die 250-ms-Transition */
    var shown = null;  /* null = noch nicht entschieden (erster IO-Callback legt fest) */
    var hideTimer = null;
    var pending = false;
    var lastIntersecting = null;
    var chatOffsetPx = 0;
    var chatTicker = null;
    var raf = window.requestAnimationFrame ? window.requestAnimationFrame.bind(window)
                                            : function (fn) { return window.setTimeout(fn, 16); };

    var CHAT_OFFSET_VAR = '--riwi-cart-sticky-offset';
    var CHAT_SEL = '#riwi-chat-launcher, #fc_frame, .fc-widget-small, .fc-widget-normal';

    function applyChatOffset() {
      var val = chatOffsetPx > 0 ? Math.round(chatOffsetPx) + 'px' : '0px';
      document.documentElement.style.setProperty(CHAT_OFFSET_VAR, val);
      var t = chatOffsetPx > 0 ? 'translateY(calc(-1 * ' + val + '))' : 'none';
      document.querySelectorAll(CHAT_SEL).forEach(function (el) {
        el.style.setProperty('transform', t, 'important');
      });
    }

    /* Freshchat injiziert #fc_frame oft erst >6s nach Load (identische Lektion wie bei der
       PDP-Leiste) -- ein begrenzter 1-s-Ticker (max. 30x) wendet den aktuellen Offset nach,
       sobald der Iframe auftaucht. Zaehler als EIGENE Variable (nicht als Property auf der
       Interval-ID -- das ist eine Zahl, kein Objekt, ein Property darauf haette unter
       'use strict' geworfen). */
    var chatTicks = 0;
    chatTicker = window.setInterval(function () {
      applyChatOffset();
      chatTicks++;
      if (document.getElementById('fc_frame') || chatTicks >= 30) {
        window.clearInterval(chatTicker);
        chatTicker = null;
      }
    }, 1000);

    function show() {
      if (shown === true) return;
      shown = true;
      if (hideTimer) { window.clearTimeout(hideTimer); hideTimer = null; }
      bar.hidden = false;
      bar.setAttribute('aria-hidden', 'false');
      void bar.offsetHeight; /* Reflow: sonst fehlt der Startwert der Transition */
      bar.classList.add('is-visible');
      chatOffsetPx = bar.getBoundingClientRect().height + 8;
      applyChatOffset();
    }

    function hide() {
      if (shown === false) return;
      shown = false;
      bar.classList.remove('is-visible');
      bar.setAttribute('aria-hidden', 'true');
      chatOffsetPx = 0;
      applyChatOffset();
      if (hideTimer) window.clearTimeout(hideTimer);
      /* hidden erst NACH der Transition setzen: es nimmt den Knopf aus der Tab-Reihenfolge,
         wuerde die Animation aber sofort abschneiden. */
      hideTimer = window.setTimeout(function () {
        hideTimer = null;
        if (shown === false) bar.hidden = true;
      }, HIDE_MS);
    }

    function apply() {
      if (lastIntersecting) hide(); else show();
    }

    function schedule() {
      if (pending) return;
      pending = true;
      raf(function () { pending = false; apply(); });
    }

    function onIntersect(entries) {
      lastIntersecting = entries[entries.length - 1].isIntersecting;
      schedule();
    }

    var io = new window.IntersectionObserver(onIntersect, { threshold: 0 });
    io.observe(anchor);

    window.addEventListener('resize', schedule, { passive: true });
    window.addEventListener('orientationchange', schedule, { passive: true });

    stickyTeardown = function () {
      io.disconnect();
      barObserver.disconnect();
      window.removeEventListener('resize', schedule);
      window.removeEventListener('orientationchange', schedule);
      if (hideTimer) window.clearTimeout(hideTimer);
      if (chatTicker) window.clearInterval(chatTicker);
      chatOffsetPx = 0;
      applyChatOffset();
    };
  }

  /* ---------------------------------------------------- AUFGABE B (W31-.us, Owner
     30.09.2026): Rueckgabe-Popup. Der Trigger-Link (data-rc-return-policy-trigger) liegt
     INNERHALB von [data-riwi-cart] und wird bei jedem Refresh per replaceWith neu erzeugt
     -- deshalb Delegation auf document, wie die anderen einmalig gebundenen Listener oben
     (Zeilen ~297ff), NICHT in activate(). Das <dialog> selbst liegt AUSSERHALB von
     [data-riwi-cart] (s. Kopf von snippets/riwi-cart-return-policy-modal.liquid) und wird
     NIE ausgetauscht -- direkte Bindung an das Element ist hier deshalb sicher und muss
     nie erneuert werden. Existiert kein Dialog (Policy-Body leer, Fallback "nur Link"),
     bleibt der Trigger ein echter <a href> -- kein preventDefault, normale Navigation. */
  var RP_LOCK_CLASS = 'riwi-cart-return-modal-lock';
  var rpLastFocused = null;

  (function initReturnPolicyModal() {
    var dialog = document.getElementById('RiwiCartReturnPolicyModal');

    document.addEventListener('click', function (event) {
      var trigger = event.target.closest && event.target.closest('[data-rc-return-policy-trigger]');
      if (!trigger) return;
      if (!dialog || typeof dialog.showModal !== 'function' || trigger.getAttribute('data-rc-has-body') !== '1') {
        return; /* Fallback "nur Link" bzw. kein <dialog>-Support: normale Navigation. */
      }
      event.preventDefault();
      rpLastFocused = trigger;
      document.documentElement.classList.add(RP_LOCK_CLASS);
      dialog.showModal();
    });

    if (!dialog) return;

    dialog.addEventListener('click', function (event) {
      /* Backdrop-Klick: .riwi-cart-return-modal hat selbst kein Padding (CSS) -- ein Klick
         AUSSERHALB von .riwi-cart-return-modal__panel trifft deshalb IMMER das <dialog>-
         Element selbst (event.target === dialog), nie einen Nachfahren. */
      if (event.target === dialog) dialog.close();
    });

    var closeBtn = dialog.querySelector('[data-rc-return-modal-close]');
    if (closeBtn) {
      closeBtn.addEventListener('click', function () { dialog.close(); });
    }

    dialog.addEventListener('close', function () {
      document.documentElement.classList.remove(RP_LOCK_CLASS);
      if (rpLastFocused && typeof rpLastFocused.focus === 'function' && document.contains(rpLastFocused)) {
        rpLastFocused.focus();
      }
      rpLastFocused = null;
    });

    /* riwi-cart.js (Drawer-Huelle) hat einen EIGENEN, ebenfalls dokumentweiten Escape-
       Listener, der bei isOpen() den Drawer schliesst -- die native <dialog>-ESC-Behandlung
       stoppt das Bubbling des keydown NICHT. Ohne stopPropagation wuerden bei geoeffnetem
       Modal innerhalb eines geoeffneten Drawers beide auf denselben Escape-Druck reagieren.
       Capture laeuft vor jedem bubble-Listener, also auch vor dem von riwi-cart.js. */
    document.addEventListener('keydown', function (event) {
      if ((event.key === 'Escape' || event.key === 'Esc') && dialog.open) event.stopPropagation();
    }, true);
  })();

  function activate() {
    document.querySelectorAll('[data-riwi-cart].no-js').forEach(function (box) {
      box.classList.remove('no-js');
    });
    document.querySelectorAll('[data-riwi-cart]').forEach(function (box) {
      initCutoff(box);
      initEdd(box);
      initStickyCheckout(box);
    });
    ensureAddonsScript();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', activate);
  } else {
    activate();
  }
  document.addEventListener('riwi-cart:updated', activate);

  window.RiwiCartContents = {
    mutate: mutate, refreshFrom: refreshFrom, isZeroBlocked: isZeroBlocked,
    ensureAddonsScript: ensureAddonsScript,
    addAndApply: addAndApply, mergeCodes: mergeCodes, currentCodes: currentCodes,
    cartUrl: cartUrl, discountRoute: discountRoute, applyCodeFromField: applyCodeFromField
  };
})();
